import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared/shared.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SevdaUgrasRoutingModule } from './sevda-ugras-routing.module';
import { SevdaUgrasComponent } from './sevda-ugras.component';
import {TranslateModule} from '@ngx-translate/core';

@NgModule({
    declarations: [SevdaUgrasComponent],
    exports: [
        SevdaUgrasComponent
    ],
    imports: [
        CommonModule,
        SevdaUgrasRoutingModule,
        SharedModule,
        NgbModule,
        TranslateModule,
    ]
})
export class SevdaUgrasModule { }
